import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BodySchemaApiService } from './body-schema-api.service';
import { BodySchemaUtilsService } from './body-schema-utils.service';
import { BodySchemaEffects } from './body-schema.effects';
import {
  bodySchemaInitialState,
  bodySchemaReducer
} from './body-schema.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('bodySchema', bodySchemaReducer, {
      initialState: bodySchemaInitialState
    }),
    EffectsModule.forFeature([BodySchemaEffects])
  ],
  providers: [BodySchemaApiService, BodySchemaUtilsService]
})
export class BodySchemaStoreModule {}
